import { PanelRoomAdvanced } from '@/components/PanelRoomAdvanced'
import { PanelRoomChat } from '@/components/PanelRoomChat'
import { PanelRoomLayouts } from '@/components/PanelRoomLayouts'
import { PanelRoomNavigator } from '@/components/PanelRoomNavigator'
import { PanelRoomOptions } from '@/components/PanelRoomOptions'
import { PanelRoomParticipants } from '@/components/PanelRoomParticipants'
import type { ReactNode } from 'react'

export type RoomPanelType = RoomPanelTypeParent | RoomPanelTypeWithParent

export type RoomPanelTypeWithParent = 'advanced' | 'layout' | 'navigator'
export type RoomPanelTypeParent = 'chat' | 'options' | 'participants'

interface PanelInfo {
  component: () => ReactNode
  parentPanelType?: RoomPanelType
  title: string
}

export const panelMap = {
  advanced: {
    component: PanelRoomAdvanced,
    parentPanelType: 'options',
    title: 'Advanced',
  },
  chat: { component: PanelRoomChat, title: 'Chat' },
  layout: {
    component: PanelRoomLayouts,
    parentPanelType: 'options',
    title: 'Layout Options',
  },
  navigator: {
    component: PanelRoomNavigator,
    parentPanelType: 'options',
    title: 'Change Rooms',
  },
  options: { component: PanelRoomOptions, title: 'Options' },
  participants: { component: PanelRoomParticipants, title: 'Participants' },
} as const satisfies Record<RoomPanelType, PanelInfo>

export const getParentPanelType = (panelType: RoomPanelType): RoomPanelType => {
  // is sub panel of a top level panel
  const parentPanel = panelMap[panelType]
  if ('parentPanelType' in parentPanel) {
    const parentPanelType = parentPanel.parentPanelType
    return parentPanelType
  }

  // is already top level panel
  return panelType
}
